export const COUNTRIES_REQUEST = 'legalEntityCatalog/COUNTRIES_REQUEST';
export const OCCUPATIONS_REQUEST = 'legalEntityCatalog/OCCUPATIONS_REQUEST';
export const STATES_REQUEST = 'legalEntityCatalog/STATES_REQUEST';
export const CITIES_REQUEST = 'legalEntityCatalog/CITIES_REQUEST';
export const TOWNSHIPS_REQUEST = 'legalEntityCatalog/TOWNSHIPS_REQUEST';
export const CIVIL_STATUS_REQUEST = 'legalEntityCatalog/CIVIL_STATUS_REQUEST';
export const BIRTH_PLACE_REQUEST = 'legalEntityCatalog/BIRTH_PLACE_REQUEST';
export const RESTRICTED_BIRTH_PLACE_REQUEST =
  'legalEntityCatalog/RESTRICTED_BIRTH_PLACE_REQUEST';
export const BENEFICIARY_COUNTRIES_REQUEST =
  'legalEntityCatalog/BENEFICIARY_COUNTRIES_REQUEST';
export const BENEFICIARY_STATES_REQUEST =
  'legalEntityCatalog/BENEFICIARY_STATES_REQUEST';
export const BENEFICIARY_CITIES_REQUEST =
  'legalEntityCatalog/BENEFICIARY_CITIES_REQUEST';
export const BENEFICIARY_TOWNSHIPS_REQUEST =
  'legalEntityCatalog/BENEFICIARY_TOWNSHIPS_REQUEST';
export const BENEFICIARY_NATIONALITY_REQUEST =
  'legalEntityCatalog/BENEFICIARY_NATIONALITY_REQUEST';
export const BENEFICIARY_OCCUPATIONS_REQUEST =
  'legalEntityCatalog/BENEFICIARY_OCCUPATIONS_REQUEST';
export const BENEFICIARY_BIRTH_PLACE_REQUEST =
  'legalEntityCatalog/BENEFICIARY_BIRTH_PLACE_REQUEST';
export const ECONOMIC_ACTIVITIES_REQUEST =
  'legalEntityCatalog/ECONOMIC_ACTIVITIES_REQUEST';
